export default __webpack_public_path__ + "static/media/par-6.e7739b86.png";